import React from "react";
import Image from "next/image";
import PrimaryBtn from "@/components/button/primaryBtn";
import en from "@/localization/en.json";

function QuestionSuccessFullSubmit({ onClick }) {
  return (
    <section className="flex flex-col items-center py-[1.7rem]">
      <div className="flex justify-center">
        <Image
          src="/assets/icons/check-success.png"
          alt="success"
          width={69}
          height={69}
        />
      </div>
      <h1 className="text-display2 text-darkPrimary text-center font-medium mt-[1.8rem] max-w-[23.625rem]">
        {en["product.question_submitted"]}
      </h1>

      <p className="text-grayD3 text-heading6 text-center mt-[1.5rem]">
        Your question will be answered shortly.
      </p>

      <div className="flex justify-center mt-[2.7rem] md:mt-[3.375rem]">
        <div className="">
          <PrimaryBtn
            btnText={en["order.continue_shopping"]}
            className="w-[18.75rem] h-[56px]"
            onClick={onClick}
          />
        </div>
      </div>
    </section>
  );
}

export default QuestionSuccessFullSubmit;
